import { render, staticRenderFns } from "./ClientActivity.vue?vue&type=template&id=1d228f14&"
import script from "./ClientActivity.vue?vue&type=script&lang=js&"
export * from "./ClientActivity.vue?vue&type=script&lang=js&"
import style0 from "./ClientActivity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports